/**
 * Demo mode configuration.
 *
 * Demo mode activates when EITHER:
 *   - The hostname is demo.frontdesko.app (production demo subdomain), OR
 *   - REACT_APP_DEMO=true is set in the environment (local / CI testing)
 *
 * Credentials are injected at build time via env vars:
 *   REACT_APP_DEMO_USER     — defaults to demo@frontdesko.com
 *   REACT_APP_DEMO_PASSWORD — defaults to 'demopassword' (placeholder)
 *
 * ASSUMPTION: The backend must have a seeded demo user matching these
 * credentials and a demo hotel with sample data. This is handled by
 * task t-demo-001 which seeds the demo environment.
 */

export function isDemoMode() {
  const envFlag = process.env.REACT_APP_DEMO === 'true';
  const subdomainFlag =
    typeof window !== 'undefined' &&
    window.location.hostname === 'demo.frontdesko.app';
  return envFlag || subdomainFlag;
}

export const DEMO_USER =
  process.env.REACT_APP_DEMO_USER || 'demo@frontdesko.com';

export const DEMO_PASSWORD =
  process.env.REACT_APP_DEMO_PASSWORD || 'demopassword';
